import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { Colors } from '../../../colors';

export const ReservationListAdminPageStyled = {
  Container: styled(Grid)<any>`
    width: 100%;
    background: ${Colors.PrimaryBackground};
    padding-left: 16px;
    padding-right: 16px;
  `,
  ListContainer: styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    background: whitesmoke;
    border-radius: 4px;
    border-collapse: separate;
    margin-top: 30px;
  `
};

